import { render, staticRenderFns } from "./PersonDocuments.vue?vue&type=template&id=3473b0b0"
import script from "./PersonDocuments.vue?vue&type=script&lang=js"
export * from "./PersonDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports